import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "clearfix" };
const _hoisted_2 = { class: "clearfix measurement-filter" };
const _hoisted_3 = { class: "btn-group pw100" };
const _hoisted_4 = { class: "measurement-options bottom10" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_7 = { class: "d-flex justify-content-start mt-2" };
const _hoisted_8 = { class: "ms-2" };
const _hoisted_9 = {
    class: /*@__PURE__*/ _normalizeClass(['component-tree-wrapper']),
    style: { "max-height": "350px", "height": "350px" }
};
const _hoisted_10 = { class: "component-tree component-tree-small" };
const _hoisted_11 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_ComponentTreeVue = _resolveComponent("ComponentTreeVue");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { class: "normal" }, "Measurement", -1 /* CACHED */)),
            _cache[6] || (_cache[6] = _createTextVNode()),
            _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMeasurementCategories, (category, index) => {
                    return (_openBlock(), _createBlock(_component_b_button, {
                        class: "pw100 tabs",
                        key: category.measurementCategoryId,
                        variant: _ctx.measurementCategory.measurementCategoryName == category.measurementCategoryName ? 'primary' : 'outline-secondary',
                        onClick: ($event) => (_ctx.setMeasurementCategory(category))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(category.measurementCategoryName), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["variant", "onClick"]));
                }), 128 /* KEYED_FRAGMENT */))
            ]),
            _cache[7] || (_cache[7] = _createTextVNode()),
            _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measurementTypeVisible, (item, itemIdx) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(['measurement-option', _ctx.measurementType == item ? 'selected-option' : '']),
                        onClick: ($event) => (_ctx.setMeasurementType(item))
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(['title', _ctx.measurementType == item ? 'white' : ''])
                        }, _toDisplayString(item.measurementTypeName), 3 /* TEXT, CLASS */)
                    ], 10 /* CLASS, PROPS */, _hoisted_5));
                }), 256 /* UNKEYED_FRAGMENT */))
            ])
        ]),
        _cache[23] || (_cache[23] = _createTextVNode()),
        (_ctx.measurementTypeRequiresNode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_b_input_group, {
                    class: _normalizeClass(['clearfix bottom0 popup-selection-control', _ctx.areNodesInvalid ? 'is-invalid' : '']),
                    title: _ctx.selectedLocationsTitle,
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.locationsModalVisible = true))
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_b_form_input, {
                            placeholder: _ctx.selectedLocationsPlaceholder,
                            value: _ctx.selectedLocationsText,
                            readonly: ""
                        }, null, 8 /* PROPS */, ["placeholder", "value"]),
                        _cache[9] || (_cache[9] = _createTextVNode()),
                        _createVNode(_component_b_input_group_append, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_b_button, {
                                    type: "button",
                                    variant: "outline-secondary"
                                }, {
                                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                            _createTextVNode("\r\n\t\t\t\t\t\t...\r\n\t\t\t\t\t", -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["class", "title"]),
                _cache[18] || (_cache[18] = _createTextVNode()),
                _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_b_button, {
                        class: "me-2",
                        variant: "primary",
                        onClick: _ctx.selectAllLocations
                    }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                _createTextVNode("Select All", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _cache[12] || (_cache[12] = _createTextVNode()),
                    _createVNode(_component_b_button, {
                        variant: "primary",
                        onClick: _ctx.unselectAllLocations
                    }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                _createTextVNode("Unselect All", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ]),
                _cache[19] || (_cache[19] = _createTextVNode()),
                _createElementVNode("div", _hoisted_8, [
                    _withDirectives((_openBlock(), _createBlock(_component_b_form_checkbox, {
                        id: "displayValue",
                        modelValue: _ctx.selectAllByDefault,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectAllByDefault) = $event)),
                        switch: ""
                    }, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                _createElementVNode("label", { class: "normal" }, "Select All by default", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])), [
                        [
                            _directive_b_tooltip,
                            void 0,
                            void 0,
                            {
                                right: true,
                                hover: true
                            }
                        ]
                    ])
                ]),
                _cache[20] || (_cache[20] = _createTextVNode()),
                _createCommentVNode(" Begin::Locations Modal "),
                _cache[21] || (_cache[21] = _createTextVNode()),
                _createVNode(_component_b_modal, {
                    modelValue: _ctx.locationsModalVisible,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.locationsModalVisible) = $event)),
                    id: _ctx.locationsModalId,
                    "header-bg-variant": "normal",
                    size: "md",
                    static: true
                }, {
                    title: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                            _createTextVNode("\r\n\t\t\t\t\tLocations\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_b_button, {
                                type: "button",
                                variant: "secondary",
                                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.locationsModalVisible = false))
                            }, {
                                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                        _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                        _createTextVNode(" Close\r\n\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ]),
                    default: _withCtx(() => [
                        _cache[16] || (_cache[16] = _createTextVNode()),
                        _createVNode(_component_b_container, { clearfix: "" }, {
                            default: _withCtx(() => [
                                (_openBlock(), _createElementBlock("div", {
                                    class: "clearfix",
                                    key: _ctx.componentTreeKey
                                }, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("ul", _hoisted_10, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleComponentTree, (child, index) => {
                                                return (_openBlock(), _createBlock(_component_ComponentTreeVue, {
                                                    ref_for: true,
                                                    ref: "componentTreeVueList",
                                                    key: index,
                                                    item: child,
                                                    "measurement-type": _ctx.measurementType,
                                                    "parent-id": -1,
                                                    "selected-nodes": _ctx.query.nodes,
                                                    "onUpdate:selectedNodes": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.nodes) = $event))
                                                }, null, 8 /* PROPS */, ["item", "measurement-type", "selected-nodes"]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ])
                                ]))
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _cache[17] || (_cache[17] = _createTextVNode())
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "id"]),
                _cache[22] || (_cache[22] = _createTextVNode()),
                _createCommentVNode(" End::Locations Modal ")
            ]))
            : _createCommentVNode("v-if", true)
    ]));
}
